import {Stack} from 'shells/layout/stack/stack';
import {TextFieldDebounced} from 'shells/textfield/textfield-debounced';
import {Body} from 'shells/typography/body';

import {SAVE_DELAY} from './consts';

export type Props = {
    value: string;
    onChangeCustomNumber: (value: string) => void;
    onBlur: () => void;
    errorMessage: string | null | undefined;
};

export const CustomNumberInput = (props: Props) => {
    return (
        <Stack spacing={8}>
            <TextFieldDebounced
                placeholder='(555) 555 5555'
                value={props.value}
                onChange={props.onChangeCustomNumber}
                onBlur={props.onBlur}
                delay={SAVE_DELAY}
                hasError={Boolean(props.errorMessage)}
            />
            {props.errorMessage && (
                <Body color='error' size='small'>
                    {props.errorMessage}
                </Body>
            )}
        </Stack>
    );
};
